<template>
  <div
    class="d-flex flex-column flex-lg-row justify-content-between align-items-center w-100 text-dark-3 pb-space-xs border-bottom list-component"
  >
    <div class="title-block align-self-start w-100 mb-space-sm mb-lg-0">
      <h4 class="h4-medium mb-space-xxs d-none d-lg-block">
        {{ title }}
      </h4>
      <h3 class="h3-medium mb-space-xxs d-lg-none">
        {{ title }}
      </h3>
      <span class="text-dark-1">{{ category }}</span>
    </div>
    <div class="d-flex content-right justify-content-between">
      <span class="d-none d-lg-block">Starts: {{ date }}</span>
      <span class="d-block d-lg-none">Next start date: {{ date }}</span>
      <NuxtLink :to="link" class="d-flex">
        <span>Learn more</span
        ><button
          class="ms-space-xs rounded-circle circle-btn d-flex justify-content-center align-items-center"
          aria-label="learn more"
          tabindex="-1"
        >
          <FontAwesomeIcon :icon="['fas', 'chevron-right']" />
        </button>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

defineProps<{
  title: string;
  category: string;
  date: string;
  link: string;
}>();
</script>

<style scoped lang="scss">
.list-component {
  &:hover,
  &:focus {
    .title-block {
      padding-left: 8px !important;
    }
    .circle-btn {
      background-color: var(--rds-primary);
      color: var(--rds-light-1);
    }
  }
}
.title-block {
  transition: padding-left 300ms linear;
  max-width: 400px;
}
.content-right {
  width: 100%;
  // gap: 24px;
  @media screen and (min-width: 992px) {
    width: fit-content;
    gap: 48px;
  }
  @media screen and (min-width: 1200px) {
    gap: 100px;
  }
}
.circle-btn {
  width: 24px;
  height: 24px;
  font-size: 10px;
  color: var(--rds-dark-3, #191919);
  border: 1px solid var(--rds-light-3, #e8e8e8);
  background-color: var(--rds-light-1, #fafafa);
  transition:
    color 300ms linear,
    background-color 300ms linear;
}
</style>
